<template>
    <div class="segment" :style="`width: ${width}%`">
        <span :id="ids.zoom" class="zoom-number" v-if="ShowNumber()">{{ zoom }}</span>
        <span class="marker" v-else></span>
    </div>
</template>

<script>
export default {
    name: "TimelineZoomSegment",
    props: {
        zoom: Number,
        total: Number,
        index: Number
    },
    data: () => ({
        width: 0,
        ids: { zoom: "" }
    }),
    methods: {
        ShowNumber: function() {
            const middleNumber = Math.floor(this.total / 2);
            return this.index === 0
                || this.zoom === middleNumber
                || this.Last();
        },
        Last: function() { return this.zoom === this.total; }
    },
    beforeMount: function() {
        this.width = 100 / this.total;
        this.ids.zoom = this.Last() ? "zoom-number-shift" : "";
    }
};
</script>